//-------------------------\\
//--- Classes des views ---\\
//-------------------------\\

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Dans ce fichier, on retrouve les différentes fonctions utilisées par les views dans transition.js. Ces fonction
// vont servir à appeler les scripts spécifiques ou les plugins utilisés dans les page web. Les fonctions appelées
// sont réparties dans différents fichiers (slicks, overlay), afin de garder le tout le plus structuré possible.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import $ from 'jquery'
import Scrollbar from 'smooth-scrollbar'
import svg4everybody from 'svg4everybody/dist/svg4everybody.legacy.js'
import { removeHoverOnMobile, noSamePageDestination, isIE } from './functions/helper.js'
import { getScrollType, addFixedElements } from './functions/scroll.js'
import { scrollToBlock, rubrics, alert, sideNav, calendar } from './functions/functions.js'
import { slickBanner, slickEvents, destroySlick } from './functions/slicks.js'
import { dropDownHeader, overlayFastLinks, overlayMenu, overlaySearch, overlayShare, overlayCalendar } from './functions/overlay.js'
import { magicSelect, fixInput, formContact, formSearch, formJob, formInfolettre, changeLabelUpload } from './functions/forms.js'
import { TyperSetup } from './functions/typer.js'
import { Parallax } from './classes/Parallax.js'
import { Scrollfire } from './classes/Scrollfire.js'
import { manageCookies } from './functions/manageCookies.js';
//-----------------------------------------------------------------------------------------------------------------


// Initialisation sur toutes les pages
export class View {
  static init() {
    manageCookies()
    svg4everybody()
    removeHoverOnMobile()
    noSamePageDestination()
    getScrollType()
    window.lazyLoad.lazyBackground()
    window.parallax = new Parallax()
    window.scrollfire = new Scrollfire()
    addFixedElements()
    dropDownHeader()
    overlayMenu()
    overlaySearch()
    overlayShare()
    overlayFastLinks()
    alert()
    fixInput()
    formSearch('#formSearchOverlay', '#submitSearchOverlay')
    formInfolettre()
    scrollToBlock('#scrollBackToTop', '')
    TyperSetup()
  }

  static leave() {
    $(window).off('scroll')
    setTimeout(()=>{
      window.parallax.destroy()
      Scrollbar.destroyAll()
    }, 900)
    window.scrollfire.destroy()
  }
}


// Classe initialisant les scripts présents dans la page d'accueil
export class Home extends View {
  static initHome() {
    window.activeView = 'home'
    this.init()
    slickBanner()
    slickEvents()
    formSearch('#formSearch', '#submitSearch')
  }

  static leaveHome() {
    this.leave()
    destroySlick('#slickBanner')
    destroySlick('#slickEventsImages')
    destroySlick('#slickEventsText')
  }
}


// Classe initialisant les scripts présents dans la page d'actualité
export class News extends View {
  static initNews() {
    window.activeView = 'news'
    this.init()
    magicSelect()
  }

  static leaveNews() { this.leave() }
}


// Classe initialisant les scripts présents dans la page de détail d'une actualité
export class NewsDetail extends View {
  static initNewsDetail() {
    window.activeView = 'newsDetail'
    this.init()
    sideNav()
  }

  static leaveNewsDetail() { this.leave() }
}


// Classe initialisant les scripts présents dans la page de documents
export class Documents extends View {
  static initDocuments() {
    window.activeView = 'documents'
    this.init()
    sideNav()
    magicSelect()
    rubrics()
  }

  static leaveDocuments() { this.leave() }
}


// Classe initialisant les scripts présents dans la page de rubrique
export class Rubric extends View {
  static initRubric() {
    window.activeView = 'rubric'
    this.init()
    sideNav()
    rubrics()
    if($('.formBlock').length){formContact()}
  }

  static leaveRubric() { this.leave() }
}


// Classe initialisant les scripts présents dans la page des emplois
export class Jobs extends View {
  static initJobs() {
    window.activeView = 'jobs'
    this.init()
    sideNav()
    magicSelect()
  }

  static leaveJobs() { this.leave() }
}


// Classe initialisant les scripts présents dans la page de détail d'un emploi
export class Job extends View {
  static initJob() {
    window.activeView = 'job'
    this.init()
    formJob()
    sideNav()
    changeLabelUpload()
  }

  static leaveJob() { this.leave() }
}


// Classe initialisant les scripts présents dans la page des événements
export class Events extends View {
  static initEvents() {
    window.activeView = 'events'
    this.init()
    sideNav()
    magicSelect()
    overlayCalendar()
  }

  static leaveEvents() { this.leave() }
}


// Classe initialisant les scripts présents dans la page de détail d'un événement
export class Event extends View {
  static initEvent() {
    window.activeView = 'event'
    this.init()
    sideNav()
  }

  static leaveEvent() { this.leave() }
}


// Classe initialisant les scripts présents dans la page de la recherche
export class Search extends View {
  static initSearch() {
    window.activeView = 'search'
    this.init()
    magicSelect()
  }

  static leaveSearch() { this.leave() }
}


// Classe initialisant les scripts présents dans la page d'une section
export class Section extends View {
  static initSection() {
    window.activeView = 'section'
    this.init()
  }

  static leaveSection() { this.leave() }
}


// Classe initialisant les scripts présents dans la page de contact
export class Contact extends View {
  static initContact() {
    window.activeView = 'contact'
    this.init()
    formContact()
    rubrics()
  }

  static leaveContact() { this.leave() }
}
